import { type UseMutationOptions, useMutation } from '@tanstack/react-query'
import type { AxiosError } from 'axios'
import {
	type HttpDeallocateImagesOptions,
	httpDeallocateImages
} from '@/features/photoset/http/photoset.http'
import { MUTATION_KEYS } from '@/query-client'

export const useDeallocateImages = (
	options?: Omit<
		UseMutationOptions<unknown, AxiosError, HttpDeallocateImagesOptions>,
		'mutationFn' | 'mutationKey'
	>
) => {
	return useMutation({
		...options,
		mutationKey: [MUTATION_KEYS.DEALLOCATE_IMAGES],
		mutationFn: httpDeallocateImages
	})
}
